import { memoize } from 'lodash-es';
/**
 * Loads a script into the document body.
 * @param {LoadScriptOptions} options
 * @returns {Promise<void>} A promise that resolves when the script is loaded.
 */
async function _loadScript({ id, src, async, defer, textContent, type, attrs, }) {
    return new Promise((resolve, reject) => {
        // ast-grep-ignore: no-manual-script-creation
        const script = document.createElement('script');
        if (id) {
            script.id = id;
        }
        if (async) {
            script.async = true;
        }
        if (defer) {
            script.defer = true;
        }
        if (type) {
            script.type = type;
        }
        if (attrs) {
            for (const [key, value] of Object.entries(attrs)) {
                script.setAttribute(key, value);
            }
        }
        if (src) {
            script.src = src;
            script.onload = () => resolve();
            script.onerror = reject;
        }
        else if (textContent) {
            script.textContent = textContent;
        }
        document.body.appendChild(script);
        if (textContent) {
            resolve();
        }
    });
}
export const loadScript = memoize(_loadScript, (opts) => opts.id || opts.src || opts.textContent);
//# sourceMappingURL=loadScript.js.map